import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
import { BaseColumnComponent } from '../../base-widget'
/**
 * 数値表示カラム
 *【内容:content:number】
 *【グループ化項目:groupItems:string[]】
 *【ハイライト:highlight:string】
 *【単位:unit:string】
 *【パーセント表示:percent:boolean】
 *【小数表示:decimalDisplay:boolean】
 *【小数桁数:decimalDigit:number】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-number-display-column',
  templateUrl: './number-display-column.html',
  styles: [`
    .mat-icon-button {
      line-height: 20px;
      height: 20px;
      width: 20px;
    }
  `]
})
export class NumberDisplayColumn extends BaseColumnComponent {
  /**
   * 項目添字
   */
  @Input() index:number

  /**
   * リスト内容
   */
  @Input() records:any[]

  /**
   * 内容の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 内容に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * 内容
   */
  @Input() content:number

  /**
   * グループ化項目
   */
  @Input() groupItems:string[]

  /**
   * ハイライト
   */
  @Input() highlight:string

  /**
   * 単位
   */
  @Input() unit:string

  /**
   * パーセント表示
   */
  @Input() percent:boolean

  /**
   * 小数表示
   */
  @Input() decimalDisplay:boolean

  /**
   * 小数桁数
   */
  @Input() decimalDigit:number

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  get htmlId():string {
    return `${this.id}[${this.index}]`
  }
  getHighlight() {
    if (this.highlight === 'attention') {
      return 'highlight-attention'
    } else if (this.highlight === 'positive') {
      return 'highlight-positive'
    } else if (this.highlight === 'negative') {
      return 'highlight-negative'
    }
    return
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/table/number-display-column/number-display-column.component.ts